import React from 'react';
import StoryCraftLayout from '../StoryCraftLayout';

const AdaptiveLayout: React.FC = () => {
    // Single responsive layout for all screen sizes
    return <StoryCraftLayout />;
};

export default AdaptiveLayout;
